import React, {Component} from "react";
import Grid from '@material-ui/core/Grid';
import Wedo1 from '../../../images/wedo/w1.png';
import Wedo2 from '../../../images/wedo/w2.png';
import Wedo3 from '../../../images/wedo/w3.png';
import Wedo4 from '../../../images/wedo/w4.png';
import {Link} from "react-router-dom";
import OurServicePage from "../../OurService/OurServicePage";
import ContactPage from "../../Contact/ContactPage";


class WhatWeDo extends Component {
    render() {
        return (
            <section className="what-we-do section-padding websitePadding" id="whatwedo">
                <Grid container spacing={3}>
                    <Grid item lg={1} xs={12}></Grid>
                    <Grid item lg={10} xs={12} className="offset-lg-1 col-12 text-center">
                        <Grid className="what-we-do-title">
                            <span>what we do</span>
                            <h2>We bring design to life using Drywall Solutions and, <span>Best services is our commitment.</span>
                            </h2>
                        </Grid>
                    </Grid>
                    <Grid item md={3} sm={6} xs={12} className="text-center">
                        <Grid className="single-we-do">
                            <img src={Wedo1} alt=""/>
                            <h3>Drywall</h3>
                            <p>We provide drywall installtion, finishing and repair work.</p>
                        </Grid>
                    </Grid>
                    <Grid item md={3} sm={6} xs={12} className="text-center">
                        <Grid className="single-we-do">
                            <img src={Wedo2} alt=""/>
                            <h3>Texture</h3>
                            <p>We do spray ceiling, reapir old spray and popcorn ceiling.</p>
                        </Grid>
                    </Grid>
                    <Grid item md={3} sm={6} xs={12} className="text-center">
                        <Grid className="single-we-do">
                            <img src={Wedo3} alt=""/>
                            <h3>Steel Framing</h3>
                            <p>We provide structural and light gauge steel framing.</p>
                        </Grid>
                    </Grid>
                    <Grid item md={3} sm={6} xs={12} className="text-center">
                        <Grid className="single-we-do">
                            <img src={Wedo4} alt=""/>
                            <h3>Insultation</h3>
                            <p>We provide all kind of insulation services.</p>
                        </Grid>
                    </Grid>

                    <Grid item lg={12} className="what-we-do-button text-center">
                        <Link to="/services" className="theme_btn">All Services</Link>
                        <Link to="/contact" className="theme_btn btn_tb">Contact us now</Link>
                    </Grid>
                </Grid>
            </section>

        )
    }
}

export default WhatWeDo;